import script from "./read-more-2.vue?vue&type=script&setup=true&lang=js"
export * from "./read-more-2.vue?vue&type=script&setup=true&lang=js"

import "./read-more-2.vue?vue&type=style&index=0&id=50de76ca&lang=scss"

const __exports__ = script;

export default __exports__